/*
  Figma "Tooltip": a label/primary bubble with Footnote Semibold text in bg/base and a 12 wide
  arrow, shown under its child on hover and keyboard focus, so a card's clipped cover can hold it.
*/
const Tooltip = ({ label, children, className = "" }) => (
  <span className={`group/tip relative inline-flex ${className}`}>
    {children}
    <span
      role="tooltip"
      className="pointer-events-none absolute left-0 top-full z-20 mt-[6px] hidden w-max max-w-[220px] rounded-radius-sm bg-label-primary px-[10px] py-[6px] text-footnote-semibold text-bg-base group-hover/tip:block group-focus-within/tip:block"
    >
      {label}
      <span
        aria-hidden="true"
        className="absolute bottom-full left-[14px] h-0 w-0 border-x-[6px] border-b-[6px] border-x-transparent border-b-label-primary"
      />
    </span>
  </span>
);

export default Tooltip;
